// components/Icon.jsx
// Created: 2026-03-11 15:30:00 EST
// Updated: 2026-03-11 15:30:00 EST
// Project: Giving Words to Voices
// Author: Michael Schwarz
// Version: 1.0.0
//
// Icon stroke context — lets every Icon in the tree pick up the active
// stroke weight without prop drilling. App wraps everything in the provider.

import React from 'react';

// Default stroke weight — matches the original App.js default
export const IconStrokeContext = React.createContext(1.8);

// Thin wrapper — uses stroke from context; sw prop overrides per-use
export const Icon = ({ icon: I, size = 14, style = {}, sw }) => {
  const ctxSw = React.useContext(IconStrokeContext);
  return (
    <I
      size={size}
      strokeWidth={sw ?? ctxSw}
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        flexShrink: 0,
        ...style,
      }}
    />
  );
};

export default Icon;
